import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import {
  getCrashLog,
  installGlobalCrashHandlers,
} from "./diagnostics/crashLog.js";

// Install crash listeners before mounting React so any error during
// the very first render is captured. The context callback runs at
// crash time and tags the report with the current URL location.
installGlobalCrashHandlers(getCrashLog(), () => ({
  hash: window.location.hash,
  path: window.location.pathname,
}));

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
